import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Confirm } from 'react-confirm-bootstrap';
import { SplitButton, MenuItem, Alert } from 'react-bootstrap/lib';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { CrmType } from '@upstart/harmony/lib/constants';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';
import ImportCRMFormsModal from './ImportCRMFormsModal';
import './FormList.scss';

const TEST_LEADS_CRM = [CrmType.ELEAD, CrmType.VINSOLUTIONS]; // crms that require a test lead to be created
const ALLOWS_EXISTING_LEADS_CRM = [CrmType.VINSOLUTIONS]; // crms that allow extracting forms from an existing lead

class FormList extends PureComponent {
  onImportCRMForms = () => {
    const needsTestLeads = TEST_LEADS_CRM.includes(this.props.dealer.crmType);
    const allowExistingLeads = ALLOWS_EXISTING_LEADS_CRM.includes(
      this.props.dealer.crmType,
    );
    ImportCRMFormsModal({
      needsTestLeads,
      allowExistingLeads,
    }).then(({ confirm, testVisitId }) => {
      if (confirm) {
        this.props.onImportCRMForms(testVisitId);
      }
    });
  };

  actionFormatter = (cell, row) => (
    <div>
      <SplitButton
        title="Edit"
        key={row.id}
        id={`split-button-basic-${row.id}`}
        onClick={() => {
          this.props.history.push(`/${row.dealer_id}/forms/form/${row.id}`);
        }}
      >
        <Confirm
          onConfirm={() => this.props.onDelete(row.id)}
          body={`Are you sure you want to delete ${row.name}?`}
          confirmText="Confirm Delete"
          title={`Deleting ${row.name}`}
        >
          <MenuItem>Delete</MenuItem>
        </Confirm>
      </SplitButton>
    </div>
  );

  urlFormatter = (cell, row) => (
    <Link target="_blank" to={{ pathname: `${row.url}` }}>
      PDF file
    </Link>
  );

  createCustomInsertButton = dealerId => (
    <>
      <Link
        className="btn btn-primary btn-large new-btn-space"
        to={{ pathname: `/${dealerId}/forms/form/` }}
      >
        Add New
      </Link>
      <button
        className="btn btn-primary btn-large new-btn-space"
        onClick={this.onImportCRMForms}
      >
        Import from CRM
      </button>
    </>
  );

  render() {
    const { list, error, dealer, fetching, success } = this.props;

    const options = {
      insertBtn: () => this.createCustomInsertButton(dealer.id),
    };

    return (
      <div className="form-list-container">
        {fetching && <Alert>Loading...</Alert>}
        {error && <ErrorMessage error={error} />}
        {success && <SuccessMessage success={success} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn
            isKey
            dataField="name"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="url" dataFormat={this.urlFormatter}>
            URL
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

FormList.propTypes = {
  dealer: PropTypes.object,
  error: PropTypes.any,
  success: PropTypes.any,
  fetching: PropTypes.bool,
  list: PropTypes.array,
  onImportCRMForms: PropTypes.func,
  onDelete: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(FormList);
